module.exports = __webpack_public_path__ + "img/Herald.dcf14add.jpg";